import {useParams} from "react-router-dom";
import SinglePageLayout from "../../../layout/SinglePageLayout";
import {
    Alert,
    Button,
    Card,
    Col,
    DatePicker,
    Descriptions,
    Divider,
    Form,
    Input,
    message,
    Modal,
    Row,
    Select,
    Space,
    Table,
    Tag,
    Typography
} from "antd";
import React, {useEffect, useState} from "react";
import axiosInstance from "../../../variables/api/axiosInstance";
import {
    DollarOutlined,
    ExclamationCircleFilled,
    FileTextOutlined,
    InboxOutlined,
    MobileOutlined
} from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import {loadTaxes, saveReglementCheque, validateWithComment} from "../../../hooks/useHooks";
import {toast} from "react-toastify";
import TextArea from "antd/es/input/TextArea";
import {formatCurrency, formatCurrencyWithCurrencyCode, formatFrenchDate} from "../../../variables/functions";
import InvoiceCard from "../components/InvoiceCard";


const {confirm} = Modal;
const {Text, Title} = Typography
const {Option} = Select


const ReglementAttestation = () => {
    const {commandeId} = useParams();
    const [bonCommande, setBonCommande] = useState({})
    const [reload, setReload] = useState(false)
    const [selectedPaymentType, setSelectedPaymentType] = useState('VIREMENT');
    const [commentaire, setUpdateCommentaire] = useState('');
    const [fileUrl, setFileUrl] = useState(null)
    const [virementFileUrl, setVirementFileUrl] = useState(null)
    const [numeroCheque, setNumeroCheque] = useState(null)
    const [dateEmission, setDateEmission] = useState(null)
    const [banque, setBanque] = useState(null)
    const [numeroPaiement, setNumeroPaiement] = useState(null)
    const [numeroVirement, setNumeroVirement] = useState(null)
    const [numeroCompteDebit, setNumeroCompteDebit] = useState(null)
    const [identifiantPaiement, setIdentifiantPaiement] = useState(null)
    const [loadingOrders, setLoadingOrders] = useState({})
    const [taxe, setTaxe] = useState(null)

    const chequeDraggerProps = {
        name: 'file', accept: 'image/*, .pdf', multiple: false, customRequest: async (options) => {
            const {file, onSuccess, onError, onProgress} = options;
            try {

                const response = await saveReglementCheque(file);
                console.log(response)
                setFileUrl(response)
                message.success(`${file.name} téléversé avec succès.`);
            } catch (error) {
                // Handle errors
                onError(error);
                message.error(`Échec de l'upload du fichier: ${file.name}`);
            }
        }, onChange(info) {
            const {status} = info.file;
            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (status === 'done') {

                setFileUrl(sessionStorage.getItem('file'))
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        }, onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    const virementDraggerProps = {
        name: 'file', accept: 'image/*, .pdf', multiple: false, customRequest: async (options) => {
            const {file, onSuccess, onError, onProgress} = options;
            try {

                const response = await saveReglementCheque(file);
                console.log(response)
                setVirementFileUrl(response)
                message.success(`${file.name} téléversé avec succès.`);
            } catch (error) {
                // Handle errors
                onError(error);
                message.error(`Échec du téléversement du fichier: ${file.name}`);
            }
        }, onChange(info) {
            const {status} = info.file;
            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (status === 'done') {

                setVirementFileUrl(sessionStorage.getItem('file'))
                message.success(`${info.file.name} Fichier téléversé avec succes.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} Échec du téléversement du fichier.`);
            }
        }, onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    console.log(fileUrl + ' fileUrl ')


    const handlePaymentTypeChange = (value) => {
        setSelectedPaymentType(value);
    };
    console.log(selectedPaymentType)
    const typePaiement = {
        CHEQUE: "CHEQUE", ESPECE: "ESPECE", MOBILE_MONEY: "MOBILE MONEY",
    };
    const reglementBonCommandeDTO = {
        numeroCheque: numeroCheque,
        dateEmissionCheque: dateEmission,
        fichierCheque: fileUrl,
        banque: banque,
        numeroPaiement: numeroPaiement,
        identifiantPaiement: identifiantPaiement,
        modePaiement: selectedPaymentType,
        numeroVirement: numeroVirement,
        numeroCompteDebit: numeroCompteDebit,


    }
    console.log(commandeId)
    useEffect(() => {
        if (commandeId) {
            axiosInstance
                .get(`/api/bon-commande/${commandeId}`)
                .then((res) => setBonCommande(res.data))
                .catch(() => console.log("Une erreur s'est produite"));
        }
    }, [commandeId, reload]);
    useEffect(() => {
        loadTaxes(setTaxe);
    }, []);


    const getTaxe = () => {
        return (bonCommande?.reglement?.montant * taxe?.valeur) / 100;
    }


    const productColumns = [{
        title: "Numero de commande", dataIndex: "codeId", key: "codeId",
    }, {
        title: "Produit", key: "categorie", render: (_, record) => {
            const categorie = record.produitAttestation?.categorie;
            return categorie ? `${record.produitAttestation?.typeAttestation}  ${categorie.nom} (${categorie.codeCategorie})` : "N/A";
        },
    }, {
        title: "Quantité", dataIndex: "quantite", key: "quantite",
    }, {
        title: "Prix Unitaire", key: "montant", render: (_, record) => {
            const montant = record.produitAttestation?.montant;
            return montant ? ` ${formatCurrency(montant)}` : "N/A";
        },
    }, {
        title: "Total", key: "total", render: (_, record) => {
            const montant = record.produitAttestation?.montant;
            const total = montant ? montant * record.quantite : 0;
            return ` ${formatCurrency(total)}`;
        },
    },];
    const validation = (lotA, updateCommentaire, reglementBonCommandeDTO) => {
        console.log("Code de la commande à valider :", lotA);
        const com = updateCommentaire
        console.log(updateCommentaire)
        setLoadingOrders(true)
        const validationBonCommandeDTO = {
            bonCommandeCodeId: lotA, commentaire: com, reglementBonCommandeDTO: reglementBonCommandeDTO
        }
        console.log(validationBonCommandeDTO)
        validateWithComment(validationBonCommandeDTO).then(r => {
            toast("Commande validée avec succès !");
            setReload((prevState) => !prevState)
            window.location.reload()
        }).catch((error) => {
            console.error("Erreur lors de la validation :", error);
            toast("Erreur lors de la validation !");
            setLoadingOrders(false)
        });
    };

    const alertReglement = () => {
        confirm({
            title: "Etes-vous sûr de vouloir effectuer ce règlement?",
            icon: <ExclamationCircleFilled/>,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui régler",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                validation(bonCommande?.codeId, commentaire, reglementBonCommandeDTO)
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };
    const getTagColor = (statutCommande) => {
        switch (statutCommande) {
            case "INITIE":
                return "blue";
            case "VALIDE":
                return "green";
            case "AUTORISE":
                return "gold";
            case "CONFIRME":
                return "purple";
            case "DELIVRE":
                return "cyan";
            case "RECEPTIONNE":
                return "volcano";
            default:
                return "default";
        }
    };

    // Function to check if all required fields are filled
    const isFormValid = () => {
        if (!selectedPaymentType) return false;

        if (selectedPaymentType === 'CHEQUE') {
            return numeroCheque && dateEmission && banque;
        }

        if (selectedPaymentType === 'MOBILE_MONEY') {
            return numeroPaiement && identifiantPaiement;
        }

        return true;
    };

    const handleValidation = () => {
        if (!isFormValid()) {
            message.warning("Veuillez remplir tous les champs obligatoires avant de valider !");
            return;
        }

        alertReglement();
    };
    return (<>
        <SinglePageLayout>
            <Card
                bordered={false}
                title={<Title level={5} style={{margin: 0}}>
                    {`Commande numero  ${bonCommande.codeId}`}
                </Title>}
                extra={<div style={{
                    display: 'flex', flexDirection: 'row', gap: '10px'
                }}>
                    <Title level={5} style={{margin: 0}}> Statut de la commande </Title>
                    <Tag
                        color={getTagColor(bonCommande?.statutCommande)}
                        style={{float: "right"}}
                    >
                        {bonCommande.statutCommande}
                    </Tag>
                </div>}
            >
                <Row justify="space-between" align="top">
                    {/* Left side: Icon + Order Info */}
                    <Col>
                        <Space align="start" size={16}>
                            <div>
                                <Descriptions
                                    column={2}
                                    size="small"
                                    colon={true}
                                    labelStyle={{color: "#595959"}}
                                    contentStyle={{color: "#1a347d", fontWeight: '500', fontSize: '15px'}}
                                    layout={"vertical"}
                                    style={{width: '67%', marginTop: 8}}
                                >
                                    <Descriptions.Item label="Compagnie">
                                        <Text strong style={{color: "#1a347d"}}>
                                            {bonCommande.compagnie?.raisonSociale}
                                        </Text>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Date d'émission">
                                        {formatFrenchDate(bonCommande.dateEmission)}
                                    </Descriptions.Item>
                                </Descriptions>
                                <Descriptions
                                    column={3}
                                    size="middle"
                                    colon={true}
                                    labelStyle={{color: "#595959"}}
                                    contentStyle={{color: "#1a347d", fontWeight: '500', fontSize: '15px'}}
                                    style={{marginTop: 25}}
                                    layout={"vertical"}
                                >
                                    <Descriptions.Item label="Montant Hors Taxe">
                                        {formatCurrencyWithCurrencyCode(bonCommande.reglement?.montant) || 0}
                                    </Descriptions.Item>
                                    <Descriptions.Item label={`Taxe (${taxe?.valeur}%)`}>
                                        {formatCurrencyWithCurrencyCode(getTaxe()) || 0}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Montant TTC">
                                        {formatCurrencyWithCurrencyCode((bonCommande.reglement?.montant || 0) + (getTaxe() || 0))}
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        </Space>
                    </Col>
                </Row>
                <Divider/>
                <Table
                    dataSource={bonCommande?.produitAttestationCommandes?.map((unit) => ({
                        ...unit, key: unit.codeId,
                    }))}
                    columns={productColumns}
                    pagination={false}
                />
            </Card>
            <Divider/>
            <InvoiceCard items={bonCommande?.produitAttestationCommandes}
                         reglement={bonCommande?.reglement} taxe={taxe?.valeur}
                         nomCompagnie={bonCommande?.compagnie?.raisonSociale}
                         actions={bonCommande?.actionsSurCommande}/>
            <Divider/>

            <Card title="Reglement" icon={<ExclamationCircleFilled color={'blue'}/>} style={{

                width: '100%'
            }}>
                {bonCommande?.statutCommande === 'APPROUVE' ? (<div style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',

                }}>
                    {/* <Alert
                                message="Toutes vos actions sont historisées"
                                type="info"
                                showIcon
                                style={{marginBottom: '1rem'}}
                            />*/}
                    <Card style={{
                        width: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex',
                    }}>
                        <Form layout="vertical">
                            {/* Payment Type Selection */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: '30px',
                                marginBottom: '1rem'
                            }}>
                                <Button
                                    type={selectedPaymentType === 'ESPECE' ? 'primary' : 'default'}
                                    icon={<DollarOutlined/>}
                                    onClick={() => handlePaymentTypeChange('ESPECE')}
                                    style={{flex: 1}}
                                >
                                    Espèces
                                </Button>
                                <Button
                                    type={selectedPaymentType === 'CHEQUE' ? 'primary' : 'default'}
                                    icon={<FileTextOutlined/>}
                                    onClick={() => handlePaymentTypeChange('CHEQUE')}
                                    style={{flex: 1}}
                                >
                                    Chèque
                                </Button>
                                <Button
                                    type={selectedPaymentType === 'MOBILE_MONEY' ? 'primary' : 'default'}
                                    icon={<MobileOutlined/>}
                                    onClick={() => handlePaymentTypeChange('MOBILE_MONEY')}
                                    style={{flex: 1}}
                                >
                                    Mobile Money
                                </Button>
                                <Button
                                    type={selectedPaymentType === 'VIREMENT' ? 'primary' : 'default'}
                                    icon={<MobileOutlined/>}
                                    onClick={() => handlePaymentTypeChange('VIREMENT')}
                                    style={{flex: 1}}
                                >
                                    Virement
                                </Button>
                            </div>

                            {/* CHEQUE Payment Fields */}
                            {selectedPaymentType === 'CHEQUE' && (
                                <Card title="Informations du Chèque" bordered={false} style={{
                                    display: 'flex', width: '60vw', flexDirection: 'column'
                                }}>
                                    <Space direction="vertical" size="middle" style={{width: '100%'}}>
                                        <Form.Item label="Numéro de Chèque" name="numeroCheque"
                                                   style={{width: '100%'}}>
                                            <Input placeholder="Entrez le numéro du chèque"
                                                   onChange={e => setNumeroCheque(e.target.value)}
                                                   style={{borderColor: '#d9d9d9', background: '#f5f5f5'}}/>
                                        </Form.Item>
                                        <Row size="middle" style={{width: '100%'}} gutter={[16, 0]}>
                                            <Col xs={12}>
                                                <Form.Item label="Date d'Émission" name="dateEmission"
                                                           style={{flex: 1}}>
                                                    <DatePicker style={{
                                                        width: '100%',
                                                        borderColor: '#d9d9d9',
                                                        background: '#f5f5f5'
                                                    }} onChange={setDateEmission}/>
                                                </Form.Item>
                                            </Col>
                                            <Col xs={12}>
                                                <Form.Item label="Banque" name="banque" style={{flex: 1}}>
                                                    <Select placeholder="Sélectionnez une banque"
                                                            onChange={setBanque}
                                                            backgroundColor={'#f5f5f5'}
                                                            style={{
                                                                borderColor: '#d9d9d9', background: '#f5f5f5'
                                                            }}>
                                                        <Option value="banque1">Orabank</Option>
                                                        <Option value="banque2">IB Bank </Option>
                                                        <Option value="banque3">EcoBank </Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Form.Item name="fichierCheque">
                                            <Dragger {...chequeDraggerProps}>
                                                <p className="ant-upload-drag-icon"><InboxOutlined/></p>
                                                <p className="ant-upload-text">Cliquez ou glissez le fichier du
                                                    chêque ici
                                                    pour le téléverser.</p>
                                            </Dragger>
                                        </Form.Item>
                                    </Space>
                                </Card>)}

                            {/* MOBILE MONEY Payment Fields */}
                            {selectedPaymentType === 'MOBILE_MONEY' && (
                                <Card title="Informations Mobile Money" bordered={false} style={{
                                    display: 'flex', width: '60vw', flexDirection: 'column'
                                }}>
                                    <Row gutter={32} direction="vertical" size="middle" style={{width: '100%'}}>
                                        <Col xs={12}>
                                            <Form.Item label="Numéro de Paiement" name="numeroPaiement"
                                                       style={{width: '100%'}}>
                                                <Input addonBefore="+228"
                                                       placeholder="Entrez le numéro de paiement"
                                                       onChange={e => setNumeroPaiement(e.target.value)}
                                                       style={{borderColor: '#d9d9d9', background: '#f5f5f5'}}/>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12}>
                                            <Form.Item label="Identifiant de Paiement"
                                                       name="identifiantPaiement"
                                                       style={{width: '100%'}}>
                                                <Input placeholder="Entrez l'identifiant de paiement"
                                                       onChange={e => setIdentifiantPaiement(e.target.value)}
                                                       style={{borderColor: '#d9d9d9', background: '#f5f5f5'}}/>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>)}
                            {selectedPaymentType === 'VIREMENT' && (
                                <Card title="Informations Virement" bordered={false} style={{
                                    display: 'flex', width: '60vw', flexDirection: 'column'
                                }}>
                                    <Row gutter={32} direction="vertical" size="middle" style={{width: '100%'}}>
                                        <Col xs={12}>
                                            <Form.Item label="Numéro du compte débité" name="numeroComptedeb"
                                                       style={{width: '100%'}}>
                                                <Input
                                                    placeholder="Entrez le numéro du compte débité"
                                                    onChange={e => setNumeroCompteDebit(e.target.value)}
                                                    style={{borderColor: '#d9d9d9', background: '#f5f5f5'}}/>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12}>
                                            <Form.Item label="Numéro de virement"
                                                       name="identifiantVirement"
                                                       style={{width: '100%'}}>
                                                <Input placeholder="Entrez l'identifiant du virement"
                                                       onChange={e => setNumeroVirement(e.target.value)}
                                                       style={{borderColor: '#d9d9d9', background: '#f5f5f5'}}/>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row size="middle" style={{width: '100%'}} gutter={[16, 0]}>
                                        <Col xs={12}>
                                            <Form.Item label="Date de l'opération" name="dateEmission"
                                                       style={{flex: 1}}>
                                                <DatePicker style={{
                                                    width: '100%', borderColor: '#d9d9d9', background: '#f5f5f5'
                                                }} onChange={setDateEmission}/>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12}>
                                            <Form.Item label="Banque" name="banque" style={{flex: 1}}>
                                                <Select placeholder="Sélectionnez une banque"
                                                        onChange={setBanque}
                                                        backgroundColor={'#f5f5f5'}
                                                        style={{
                                                            borderColor: '#d9d9d9', background: '#f5f5f5'
                                                        }}>
                                                    <Option value="banque1">Orabank</Option>
                                                    <Option value="banque2">IB Bank </Option>
                                                    <Option value="banque3">EcoBank </Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Form.Item name="fichierVirement">
                                        <Dragger {...virementDraggerProps}>
                                            <p className="ant-upload-drag-icon"><InboxOutlined/></p>
                                            <p className="ant-upload-text">Cliquez ou glissez l'ordre de virement ici
                                                pour le téléverser.</p>
                                        </Dragger>
                                    </Form.Item>
                                </Card>)}

                            {/* Comment Section */}
                            <div style={{
                                display: 'flex',
                                width: '60vw',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                paddingLeft: '20px',
                                paddingRight: '20px'
                            }}>
                                <Form.Item label="Faites un commentaire :" name="commentaire"
                                           style={{width: '100%'}}>
                                    <TextArea rows={4} placeholder="Votre commentaire ici..."
                                              onChange={e => setUpdateCommentaire(e.target.value)}
                                              style={{borderColor: '#d9d9d9', background: '#f5f5f5'}}/>
                                </Form.Item>
                                <Button onClick={() => handleValidation()} style={{
                                    backgroundColor: '#1a347d', color: 'white', width: '30%'
                                }}> Valider </Button>
                            </div>

                        </Form>
                    </Card>
                </div>) : (
                    <Alert message="Le règlement de cette commande a été effectué" type="success" showIcon/>)}
            </Card>
        </SinglePageLayout>
    </>)
}

export default ReglementAttestation